import ContractService from "../services/contract.service";

const state = {
	contracts: [],
	oneContract: null,
	total: 0,
	columns: [
		{
			key: 'id',
			label: 'ID',
			visible: true,
			changebale: false
		},
		{
			key: 'changed',
			label: 'contract.changed',
			'class': 'td-20',
			visible: false,
			changebale: true
		},
		{
			key: 'comment',
			label: 'contract.comment',
			'class': 'td-20',
			visible: true,
			changebale: true
		},
		{
			key: 'created',
			label: 'contract.created',
			'class': 'td-20',
			visible: false,
			changebale: true
		},
		{
			key: 'version',
			label: 'contract.version',
			'class': 'td-20',
			visible: false,
			changebale: true
		},
		{
			key: 'contractDate',
			label: 'contract.contractDate',
			'class': 'td-20',
			visible: true,
			changebale: true
		},
		{
			key: 'contractNumber',
			label: 'contract.contractNumber',
			'class': 'td-20',
			visible: true,
			changebale: true,
		},
		{
			key: 'settings',
			label: 'contract.settings',
			'class': 'td-20',
			visible: false,
			changebale: true
		},
		{
			key: 'type',
			label: 'contract.type',
			'class': 'td-20',
			visible: true,
			changebale: true
		},
		{
			key: 'contragentName',
			label: 'contract.contragentName',
			'class': 'td-20',
			visible: true,
			changebale: true
		},
		{
			key: 'responsibleName',
			label: 'contract.responsibleName',
			'class': 'td-20',
			visible: true,
			changebale: true
		},
		{
			key: 'stageName',
			label: 'contract.stageName',
			'class': 'td-20',
			visible: true,
			changebale: true
		},
		{
			key: 'priceUsd',
			label: 'contract.priceUsd',
			'class': 'td-20',
			visible: true,
			changebale: true
		},
		{
			key: 'priceUzs',
			label: 'contract.priceUzs',
			'class': 'td-20',
			visible: true,
			changebale: true
		},
		{
			key: 'created_by',
			label: 'contract.created_by',
			'class': 'td-20',
			visible: false,
			changebale: true
		},
		{
			key: 'created_by_id',
			label: 'contract.created_by_id',
			'class': 'td-20',
			visible: false,
			changebale: true
		},
		{
			key: 'last_modified_by',
			label: 'contract.last_modified_by',
			'class': 'td-20',
			visible: false,
			changebale: true
		},
		{
			key: 'last_modified_by_id',
			label: 'contract.last_modified_by_id',
			'class': 'td-20',
			visible: false,
			changebale: true
		},
		{
			key: 'completed',
			label: 'contract.completed',
			'class': 'td-20',
			visible: true,
			changebale: true
		},
		{
			key: 'actions',
			label: 'goods.actions',
			'class': 'table_actions',
			visible: true,
			changebale: false
		}

	]
};


const getters = {
	columns: (state) => {
		return state.columns
	},

	getAllContracts: (state) =>{
		return state.contracts
	},

	getOneContract: (state) => {
		return state.oneContract
	},
	getTotal:(state) => {
		return state.total
	}



};


const actions = {
	async allContracts({commit},payload){
		ContractService.search(payload).then(response => {
			commit('setContracts', response.data.items);
			commit('setTotal', response.data.total);
		})
	},
	async createOrUpdateContract({commit},payload){
		ContractService.createOrUpdate(payload)
	},

	async deleteContract(commit, id){
		ContractService.deleteContract(id)
	},
	async getContract(commit,id){
		ContractService.getContract(id).then(response =>{
			commit('setContract',response.data)
		})
	}
};

const mutations = {
	setContracts: (state, payload)=> {
		state.contracts = payload
	},
	setContract:(state, payload)=> {
		state.oneContract = payload
	},
	setTotal:(state, payload) => {
		state.total = payload
	}


};

export const contract = {
	namespaced: true,
	state,
	actions,
	mutations,
	getters
};
